import "core-js/modules/es.array.slice.js";
// Copyright 2017-2022 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, u8aToU8a } from '@polkadot/util';
var SEC_LEN = 64;
var PUB_LEN = 32;
var TOT_LEN = SEC_LEN + PUB_LEN;
export function sr25519PairFromU8a(full) {
  var fullU8a = u8aToU8a(full);
  assert(fullU8a.length === TOT_LEN, function () {
    return "Expected keypair with ".concat(TOT_LEN, " bytes, found ").concat(fullU8a.length);
  });
  return {
    publicKey: fullU8a.slice(SEC_LEN, TOT_LEN),
    secretKey: fullU8a.slice(0, SEC_LEN)
  };
}